const getIndex = (phase: any, subjectName: string) => {
  const subjects = phase.subjects;
  const len = subjects.length;
  if (len) {
    for (let i = 0; i < len; i++) {
      if (subjects[i].name === subjectName) {
        return i;
      }
    }
  }
  return -1;
};

export const rebuildSubjectsArray = (droppableId: string, tree: any) => {
  const indices = droppableId.split('-');
  let phaseIndex = indices[1] === 'bulk' ? indices[2] : indices[1];

  const { phases } = tree;

  phases[phaseIndex].subjects = [];

  phases[phaseIndex].weeks.forEach((week: any) => {
    week.subjects.forEach((subject: any) => {
      let index = getIndex(phases[phaseIndex], subject.name);
      if (index === -1) {
        phases[phaseIndex].subjects.push({
          name: subject.name,
          id: subject.id,
          chapterCount: subject.chapters.length,
        });
      } else {
        phases[phaseIndex].subjects[index].chapterCount += subject.chapters.length;
      }
    });
  });
};
